import _ from 'lodash';
import React from 'react';
import { Button, Dropdown, Menu, message } from 'antd'
import { Icon } from 'xadmin-ui'
import { api, use, config, app } from 'xadmin'
import moment from 'moment'
import { HasPermission } from 'xadmin-auth'

const LoginExport = props => {
  const { user } = use('redux', state=> { return { user: state.user } })
  const { model, ids, fields, getModelState, filters, count, filter } = use('model', state => ({
    ids: state.ids,
    fields: state.filter.fields,
    filters: state.wheres.filters,
    filter: state.filter,
    count: state.count
  }))
  const [ loading, setLoading ] = React.useState(false)

  const items = React.useMemo(() => {
    const { items } = getModelState()
    items.length == 0 ? setLoading(true) : setLoading(false)
    return ids.map(id => items[id]).filter(item => !_.isNil(item))
  }, [ ids ])

        /* see Browser download file example in docs */
  const s2ab = (s/*:string*/) =>/*:ArrayBuffer*/ {
    const buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
    return buf
  }

  const onExport = key => {
    const properties = { ...model?.properties }
    let schemaKey = properties ? Object.keys(properties).map(item => item) : []
    let newArr = [ 'oldData', 'user', 'message', 'node', 'model', 'table', 'ext', 'dashboard', 'event', 'eventHandler', 'warning', 'nodes', 'signature', 'department' ]
    if(fields.length && schemaKey.length) {
      for (let i = 0; i < fields.length; i++) {
        for (let j = 0; j < schemaKey.length; j++) {
          if(schemaKey[j] === fields[i]) {
            newArr.push(schemaKey[j]);
          }
        }
      }
    }

    let obj = {}
    newArr?.length ? newArr.forEach(val=> { obj[val]= 1 }) : schemaKey?.length ? schemaKey.forEach(val => obj[val]=1 ) : {}

    if(filters?.time) {
      filters.time = { '$gte': filters?.time?.gte, '$lte': filters?.time?.lte }
    }
    if(filters?.user) {
      filters.userId = filters.user
      delete filters.user
    }
    const query = {
      skip: 0,
      limit: Number(count),
      sort: filter?.order?.time == 'DESC' ? { time: -1 } : { time: 1 },
      filter: filters || {},
      project: obj,
      withCount: true
    }
    const querystr = encodeURIComponent(JSON.stringify(query))
    setLoading(true)
    let hs = {}
    if (user && user.token) {
      hs['Authorization'] = user.token
    }
    const lastPath = location.pathname.split('/').slice(-1)[0]
    if (lastPath.startsWith('_p_')) {
      hs['x-request-project'] = lastPath.substring(3)
    }
    if (app?.module !== 'front') {
      hs['X-Access-Path'] = 'admin'
    }
    let exxportTyle = key == 'pdf' ? 'formatPdf' : key
    fetch(config('mediaUrl')+`/core/log/export/${exxportTyle}?query=${querystr}`, {
      method: 'get',
      headers: hs,
      responseType: 'blob'
    }).then(res => {
      return res.blob()
    }).then(data => {
      let type = key == 'pdf' ? 'application/pdf; charset=UTF-8' : 'application/octet-stream'
      const blob = new Blob([ data ], { type })
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      let name;
      if(key == 'pdf') {
        name = `${moment(new Date).format('YYYYMMDD')}-${moment(new Date).format('HHmmss')}.pdf` || '操作日志.pdf'
      } else if(key == 'excel') {
        name = `${moment(new Date).format('YYYYMMDD')}-${moment(new Date).format('HHmmss')}.xlsx` || '操作日志.xlsx'
      }
      link.setAttribute('download', name)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setLoading(false)
    }).catch(err=>{
      message.error(err.message,err?.detail)
      setLoading(false)
    })
  }

  const onMenuClick = (e) => {
    if(e?.key) onExport(e?.key) 
  }

  const menu = (
    <Menu
      onClick={onMenuClick}
      // items={[
      //   {
      //     key: 'pdf',
      //     label: '导出pdf',
      //   },
      //   {
      //     key: 'excel',
      //     label: '导出excel',
      //   }
      // ]}
    >
      <Menu.Item key="pdf">导出pdf</Menu.Item>
      <Menu.Item key="excel">导出excel</Menu.Item>
    </Menu>
  );

  const active = !!(!loading && items)
  return (
    // <Button onClick={onExport} disabled={!active} style={{ marginRight: 2.5 }}>
    //   <Icon type={loading ? 'loading' : 'download'} />
    //   <span>{ loading ? '正在导出中~' : '导出' }</span>
    // </Button>
    <>
      <HasPermission permission="log.export">
        <Dropdown.Button onClick={() => onExport('pdf')} disabled={!active} style={{ marginRight: 2.5 }} overlay={menu}>{ loading ? '正在导出中~' : '导出' }</Dropdown.Button>
      </HasPermission>
    </>
  )
}

export default LoginExport


